// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__1DZAw","headline":"Accordion_headline__3lGQu","closed":"Accordion_closed__1QCaX","chevron":"Accordion_chevron__3oU03"};